import {
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Typography,
} from '@material-ui/core';
import { createStyles, makeStyles } from '@material-ui/styles';
import React from 'react';
import { JupiterTheme } from '@jupiterone/jupiter-web-toolkit';
import ReportIssueForm from '.';

const useStyles = makeStyles((theme: JupiterTheme) =>
  createStyles({
    root: {
      padding: theme.spacing(1),
    },
  })
);

interface ReportIssueDialogProps {
  open: boolean;
  onClose: VoidFunction;
}

const ReportIssueDialog = ({ open, onClose }: ReportIssueDialogProps) => {
  const classes = useStyles();

  return (
    <Dialog
      open={open}
      onClose={onClose}
      classes={{ root: classes.root }}
      maxWidth="sm"
      fullWidth
    >
      <DialogTitle>
        <Typography variant="h3">Report an issue</Typography>
      </DialogTitle>
      <DialogContent>
        <ReportIssueForm onReportComplete={onClose} />
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Close</Button>
      </DialogActions>
    </Dialog>
  );
};

export default ReportIssueDialog;
